import "./TradingIdeasNextControlComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {ReplaySubject} from "rxjs";
import {TradingIdeasViewStore} from "../../../store/TradingIdeasViewStore";

export const TradingIdeasNextControl = "tfTradingIdeasNextControl";

export function tradingIdeasNextControl(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/controls/next/TradingIdeasNextControlComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasNextControlComponentController
    };
}

export class TradingIdeasNextControlComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    public readonly hasNextIdea$ = new ReplaySubject<boolean>(1);

    public readonly hasMultipleIdeas$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        this.watchHasNextIdea();
        this.watchHasMultipleIdeas();
    }

    private watchHasNextIdea() {
        this.store
            .hasNextIdea
            .takeUntil(this.destroyed$)
            .subscribe((hasNext) => this.hasNextIdea$.next(hasNext));
    }

    private watchHasMultipleIdeas() {
        this.store
            .hasMultipleIdeas
            .takeUntil(this.destroyed$)
            .subscribe((hasMultiple) => this.hasMultipleIdeas$.next(hasMultiple));
    }

    public nextIdea() {
        this.store.nextIdea();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
